export const SET_SAAL_LISTINGS = 'SET_SAAL_LISTINGS';
export const RESET_SAAL_LISTINGS = 'RESET_SAAL_LISTINGS';
export function setSaalListings(listings) {
    return (dispatch) => {
        dispatch({
            type: SET_SAAL_LISTINGS,
            listings
        });
    };
}
export function resetSaalListings() {
    return (dispatch) => {
        dispatch({
            type: RESET_SAAL_LISTINGS
        });
    };
}
